import { render, staticRenderFns } from "./ChooseAppPlatform.vue?vue&type=template&id=be1c5b88&scoped=true&"
import script from "./ChooseAppPlatform.vue?vue&type=script&lang=js&"
export * from "./ChooseAppPlatform.vue?vue&type=script&lang=js&"
import style0 from "./ChooseAppPlatform.vue?vue&type=style&index=0&id=be1c5b88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1c5b88",
  null
  
)

export default component.exports